import { authAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { forgotPasswordAPIUrls } from '../data';

type SendEmailParams = {
  email: string;
};

type SendEmailResponse = {
  message: string;
};

export const sendEmail = withLogger(
  async (params: SendEmailParams): Promise<SendEmailResponse> => {
    const { data } = await authAxiosClient.post<SendEmailResponse>(
      forgotPasswordAPIUrls.forgotPass,
      params,
    );

    return data;
  },
);
